/**
 * Motorista
 * @author Simpli CLI generator
 */
import {$, HttpBody, ID, IResource, Resource, Resp, TAG, Collection} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ResponseSerialize,
  ValidationCPF,
  ValidationEmail,
  ValidationMaxLength,
  ValidationPasswordLength,
  ValidationPhone,
  ValidationRG,
  ValidationRequired,
} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import MotoristaTransbordo from '@/model/resource/MotoristaTransbordo'
import Endereco from '@/model/resource/Endereco'
import MotoristaSchema from '@/schema/Motorista.schema'
import {ItrackCollection} from '@/helpers'
import JornadaMotorista from '@/model/resource/JornadaMotorista'
import TokenPush from '@/model/resource/TokenPush'
import MotoristaLoteRequest from '@/model/request/MotoristaLoteRequest'
import {Exclude} from 'class-transformer'
import DriverPasswordRequest from '@/model/request/DriverPasswordRequest'
import { TipoVeiculoData } from '@/helpers/TipoVeiculoData'
import TipoVeiculo from './TipoVeiculo'

export default class Motorista extends Resource {

  get $schema() {
    return MotoristaSchema(this)
  }

  get $id() {
    return this.idMotoristaPk
  }
  set $id(val: ID) {
    this.idMotoristaPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(idEnderecoFk: ID) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = idEnderecoFk
  }

  get tipoVeiculoResource() {
    return ItrackCollection.allTipoVeiculoString.get(this.tipoVeiculo)
  }
  set tipoVeiculoResource(val: IResource | null) {
    // this.tipoVeiculoFk = val && val.$id as number || 0
    this.tipoVeiculo = val && val.$id as string || ''
  }

  set tipoVeiculoFkResource(val: IResource | null) {
    this.tipoVeiculoFk = val && val.$id as number || 0
  }

  get tipoVeiculoFkResource() {
    const idTipoVeiculo = this.tipoVeiculoFk === 0 ? this.tipoVeiculoData.idTipoVeiculo : this.tipoVeiculoFk
    return TipoVeiculoData.data.get(idTipoVeiculo)
  }

  get marcaVeiculoResource() {
    return ItrackCollection.allMarcaVeiculo.get(this.marcaVeiculo)
  }
  set marcaVeiculoResource(val: IResource | null) {
    this.marcaVeiculo = val && val.$id as string || ''
  }

  get tipoCarroceriaResource() {
    return ItrackCollection.allTipoCarroceria.get(this.tipoCarroceria)
  }
  set tipoCarroceriaResource(val: IResource | null) {
    this.tipoCarroceria = val && val.$id as string || ''
  }

  get tipoVeiculoAtualizado() {
    const tipoVeiculoNome = this.tipoVeiculoData.$tag !== "" ? this.tipoVeiculoData.$tag : this.tipoVeiculo
    return tipoVeiculoNome;
  }

  get porcentagemEntregasFinalizadas() {
    if (!this.qtdEntregas) {
      return 0
    }
    return 100 * Number(this.qtdEntregasFinalizadas) / Number(this.qtdEntregas)
  }

  get ultimaDistanciaParaDestinoEmKilometros() {
    if (this.ultimaDistanciaParaDestinoEmMetros != null) {
      return (this.ultimaDistanciaParaDestinoEmMetros / 1000).toFixed(1)
    }
    return 0
  }

  get ultimaDuracaoParaDestinoFormatado() {
    let delta = this.ultimaDuracaoParaDestinoEmSegundos
    if (delta === null) return '-'

    const days = Math.floor(delta / 86400)
    delta -= days * 86400

    const hours = Math.floor(delta / 3600) % 24
    delta -= hours * 3600

    const minutes = Math.floor(delta / 60) % 60

    let format = `${$.filter.pad(String(hours))}h${$.filter.pad(String(minutes))}`

    if (days) {
      format = `${$.filter.pad(String(days))}d${format}`
    }

    return format
  }

  static async notifyMotoristas(texto: string, motoristas: ID[], todos: boolean , spinner = 'notify') {
    return await $.await.run(() => new HttpBody(Number).POST(`/user/motorista/notificacao`, {
      texto,
      motoristas,
      todos,
    }), spinner)
  }

  static cadastroMotoristaLote(model?: MotoristaLoteRequest, spinner = 'persistMotorista') {
    const fetch = async () => await new HttpBody<number[]>(Array).POST(`/user/motorista/cadastro-em-lote`, model)
    return $.await.run(fetch, spinner)
  }

  static async persistTemporaryPassword(request: DriverPasswordRequest, spinner = 'persistMotoristaPassword') {
    const fetch = async () => await new HttpBody(Number).POST(`/user/motorista/temporary-password`, request)
    return await $.await.run(fetch, spinner)
  }

  @Exclude()
  readonly $name: string = 'Motorista'

  @Exclude()
  readonly $endpoint: string = '/user/motorista{/id}'

  @Exclude()
  @ResponseSerialize(MotoristaTransbordo)
  transbordo = new MotoristaTransbordo()

  @Exclude()
   @ResponseSerialize(JornadaMotorista)
   jornadaMotorista = new JornadaMotorista()

  @Exclude()
  @ResponseSerialize(TokenPush)
  tokenPush = new TokenPush()

  @ResponseSerialize(Endereco)
  endereco = new Endereco()

  @Exclude()
  @ResponseSerialize(Carga)
  cargasIniciadas: Carga[] = []

  idMotoristaPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  @ValidationMaxLength(255)
  @ValidationCPF()
  cpf: string = ''

  rg: string = ''

  @ValidationRequired()
  @ValidationMaxLength(255)
  @ValidationPhone()
  celular: string = ''

  /**
   * Pode ser null porque o responsavel poderá cadastrar, so o motorista informa este campo.
   */
  @ValidationRequired()
  @ValidationMaxLength(255)
  placaVeiculo: string = ''

  /**
   * Senha não é obrigatorio porque o responsavel pode cadastrar.
   * O Motorista que deverá informar ao receber codigo do SMS
   */
  @ResponseHidden()
  senha: string | null = null

  /**
   * Utilizar para cadastro e esqueci senha
   */
  @Exclude()
  codigoSms: string = ''

  @ValidationRequired()
  dataNascimento: string | null = null

  @ValidationRequired()
  @ValidationMaxLength(255)
  @ValidationEmail()
  email: string = ''

  telefoneFixo: string | null = null

  @ResponseSerialize(TipoVeiculo)
  tipoVeiculoData = new TipoVeiculo()
  tipoVeiculo: string = ''
  @ValidationRequired()
  tipoVeiculoFk: any = 0

  tipoCarreta: string | null = null
  tipoCarroceria: string | null = null
  placaCarroceira: string | null = null
  antt: string | null = null
  rntrc: string | null = null
  cnh: string | null = null

  /**
   * Pode ser null porque o responsavel pode cadastrar sem foto e o motorista pode não informar
   */
  @Exclude()
  urlImagem: string | null = null
  @Exclude()
  dataCriacao: string | null = null
  @Exclude()
  ativo: boolean = true
  marcaVeiculo: string | null = null
  @Exclude()
  idResponsavelCriadorFk: ID = 0
  @Exclude()
  nomeIndicador: string | null = null
  @Exclude()
  tokenAndroid: string | null = null
  @Exclude()
  versao: string | null = null
  @Exclude()
  marcaAparelho: string | null = null
  @Exclude()
  modeloAparelho: string | null = null
  ultimaDistanciaParaDestinoEmMetros: number | null =  null
  ultimaDuracaoParaDestinoEmSegundos: number | null =  null
  @Exclude()
  idUltimaPosicaoFk: number | null = null
  qtdEmAndamento: number | null = null
  qtdEntregasFinalizadas: number | null = null
  qtdEntregasFinalizadasViaWeb: number | null = null
  qtdEntregas: number | null = null
  qtdEntregasViaWeb: number | null = null

  qtdEntregasFinalizadasSucesso: number | null = null
  qtdEntregasFinalizadasOcorrencia: number | null = null
  qtdEntregasDevolvidas: number | null = null
  qtdEntregasPendentes: number | null = null

  dataInicioEntrega: string | null = null

  isEditable(idLoggedResponsavel: ID) {
    return this.idResponsavelCriadorFk === idLoggedResponsavel
  }

  async persistMotorista(model?: Motorista, spinner = 'persistMotorista') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/motorista`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async persistMotoristaTransbordo(spinner = 'persistMotorista') {
    const fetch = async () => {
      return await this.POST(`/user/motorista/transbordo`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getMotorista(id: number, spinner = 'getMotorista') {
    const fetch = async () => await this.GET(`/user/motorista/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async checkExists(cpf: string, spinner = 'checkExists') {
    const fetch = async () => await this.GET(`/user/motorista/cpf/${cpf}/existe`)
    return await $.await.run(fetch, spinner)
  }

    async connect(cpf: string, spinner = 'connect') {
        const fetch = async () => await this.POST(`/user/motorista/cpf/${cpf}/connect`)
        return await $.await.run(fetch, spinner)
    }

  async removeMotorista(id: ID, spinner = 'removeMotorista') {
    const fetch = async () => await this.DELETE(`/user/motorista/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
